import { TriangleAlert } from 'lucide-react';
import { Inline } from '../../../../design-system/inline/inline';
import { Stack } from '../../../../design-system/stack/stack';

export const DuplicateVendorCard = () => {
  return (
    <Inline align="start" space={3} className="rounded-lg border border-seapoint-gray-border bg-white px-4 py-3">
      <div className="h-10 w-10 rounded-full bg-seapoint-red/15 p-2.5">
        <TriangleAlert className="h-full w-full text-seapoint-red" />
      </div>

      <Stack space={1} className="flex-1">
        <h3 className="text-base font-semibold text-seapoint-red">A vendor with this name already exists.</h3>

        <p className="text-sm font-medium text-seapoint-gray-text">
          You can either change the name or merge the transactions for these vendors.
        </p>
      </Stack>
    </Inline>
  );
};
